// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/vision_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";
import { Point2D, protoMetadata as protoMetadata2 } from "./geometry";

export const protobufPackage = "visionbot";

export enum ErrorCode {
  UNKNOWN_ERROR = 0,
  MODEL_NOT_FOUND = 1,
  INVALID_IMAGE = 2,
  INFERENCE_FAILED = 3,
  INVALID_MODEL_TYPE = 4,
  INVALID_THRESHOLDING_PARAMS = 5,
  UNRECOGNIZED = -1,
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "UNKNOWN_ERROR":
      return ErrorCode.UNKNOWN_ERROR;
    case 1:
    case "MODEL_NOT_FOUND":
      return ErrorCode.MODEL_NOT_FOUND;
    case 2:
    case "INVALID_IMAGE":
      return ErrorCode.INVALID_IMAGE;
    case 3:
    case "INFERENCE_FAILED":
      return ErrorCode.INFERENCE_FAILED;
    case 4:
    case "INVALID_MODEL_TYPE":
      return ErrorCode.INVALID_MODEL_TYPE;
    case 5:
    case "INVALID_THRESHOLDING_PARAMS":
      return ErrorCode.INVALID_THRESHOLDING_PARAMS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.UNKNOWN_ERROR:
      return "UNKNOWN_ERROR";
    case ErrorCode.MODEL_NOT_FOUND:
      return "MODEL_NOT_FOUND";
    case ErrorCode.INVALID_IMAGE:
      return "INVALID_IMAGE";
    case ErrorCode.INFERENCE_FAILED:
      return "INFERENCE_FAILED";
    case ErrorCode.INVALID_MODEL_TYPE:
      return "INVALID_MODEL_TYPE";
    case ErrorCode.INVALID_THRESHOLDING_PARAMS:
      return "INVALID_THRESHOLDING_PARAMS";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Represents a 2D blob detection result */
export interface Blob2D {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  score: number;
  contour: Point2D[];
}

/** Available model information */
export interface Model {
  modelPath: string;
}

export interface ModelList {
  models: Model[];
}

/** Request to run inference on an image */
export interface RunCheckpointBasedInferenceRequest {
  /** Image data as bytes */
  image: Uint8Array;
  /** Path to the model checkpoint file */
  modelPath: string;
  /** Type of model to determine preprocessing/postprocessing */
  modelType: string;
  /** Model-specific thresholding parameters */
  thresholdingParams: { [key: string]: string };
}

export interface RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
  key: string;
  value: string;
}

/** Response from inference */
export interface RunCheckpointBasedInferenceResponse {
  /** Successful inference result */
  data?:
    | CheckpointBasedInferenceResult
    | undefined;
  /** Error information */
  error?: Error | undefined;
}

/** Successful inference result */
export interface CheckpointBasedInferenceResult {
  /** Detected blobs */
  blobs: Blob2D[];
  /** Processing time in milliseconds */
  processingTimeMs?:
    | number
    | undefined;
  /** Model path */
  modelPath?: string | undefined;
}

/** Error information */
export interface Error {
  code: ErrorCode;
  message: string;
}

function createBaseBlob2D(): Blob2D {
  return { x: 0, y: 0, width: 0, height: 0, rotation: 0, score: 0, contour: [] };
}

export const Blob2D: MessageFns<Blob2D> = {
  encode(message: Blob2D, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.width !== 0) {
      writer.uint32(25).double(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(33).double(message.height);
    }
    if (message.rotation !== 0) {
      writer.uint32(45).float(message.rotation);
    }
    if (message.score !== 0) {
      writer.uint32(53).float(message.score);
    }
    for (const v of message.contour) {
      Point2D.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Blob2D {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlob2D();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.width = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.rotation = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.score = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.contour.push(Point2D.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Blob2D {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      rotation: isSet(object.rotation) ? globalThis.Number(object.rotation) : 0,
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      contour: globalThis.Array.isArray(object?.contour) ? object.contour.map((e: any) => Point2D.fromJSON(e)) : [],
    };
  },

  toJSON(message: Blob2D): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.rotation !== 0) {
      obj.rotation = message.rotation;
    }
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.contour?.length) {
      obj.contour = message.contour.map((e) => Point2D.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Blob2D>, I>>(base?: I): Blob2D {
    return Blob2D.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Blob2D>, I>>(object: I): Blob2D {
    const message = createBaseBlob2D();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.rotation = object.rotation ?? 0;
    message.score = object.score ?? 0;
    message.contour = object.contour?.map((e) => Point2D.fromPartial(e)) || [];
    return message;
  },
};

function createBaseModel(): Model {
  return { modelPath: "" };
}

export const Model: MessageFns<Model> = {
  encode(message: Model, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelPath !== "") {
      writer.uint32(10).string(message.modelPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Model {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Model {
    return { modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : "" };
  },

  toJSON(message: Model): unknown {
    const obj: any = {};
    if (message.modelPath !== "") {
      obj.modelPath = message.modelPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Model>, I>>(base?: I): Model {
    return Model.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Model>, I>>(object: I): Model {
    const message = createBaseModel();
    message.modelPath = object.modelPath ?? "";
    return message;
  },
};

function createBaseModelList(): ModelList {
  return { models: [] };
}

export const ModelList: MessageFns<ModelList> = {
  encode(message: ModelList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.models) {
      Model.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.models.push(Model.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelList {
    return { models: globalThis.Array.isArray(object?.models) ? object.models.map((e: any) => Model.fromJSON(e)) : [] };
  },

  toJSON(message: ModelList): unknown {
    const obj: any = {};
    if (message.models?.length) {
      obj.models = message.models.map((e) => Model.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelList>, I>>(base?: I): ModelList {
    return ModelList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelList>, I>>(object: I): ModelList {
    const message = createBaseModelList();
    message.models = object.models?.map((e) => Model.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceRequest(): RunCheckpointBasedInferenceRequest {
  return { image: new Uint8Array(0), modelPath: "", modelType: "", thresholdingParams: {} };
}

export const RunCheckpointBasedInferenceRequest: MessageFns<RunCheckpointBasedInferenceRequest> = {
  encode(message: RunCheckpointBasedInferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.image.length !== 0) {
      writer.uint32(10).bytes(message.image);
    }
    if (message.modelPath !== "") {
      writer.uint32(18).string(message.modelPath);
    }
    if (message.modelType !== "") {
      writer.uint32(26).string(message.modelType);
    }
    Object.entries(message.thresholdingParams).forEach(([key, value]) => {
      RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork(),
      ).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCheckpointBasedInferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.thresholdingParams[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceRequest {
    return {
      image: isSet(object.image) ? bytesFromBase64(object.image) : new Uint8Array(0),
      modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : "",
      modelType: isSet(object.modelType) ? globalThis.String(object.modelType) : "",
      thresholdingParams: isObject(object.thresholdingParams)
        ? Object.entries(object.thresholdingParams).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: RunCheckpointBasedInferenceRequest): unknown {
    const obj: any = {};
    if (message.image.length !== 0) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.modelPath !== "") {
      obj.modelPath = message.modelPath;
    }
    if (message.modelType !== "") {
      obj.modelType = message.modelType;
    }
    if (message.thresholdingParams) {
      const entries = Object.entries(message.thresholdingParams);
      if (entries.length > 0) {
        obj.thresholdingParams = {};
        entries.forEach(([k, v]) => {
          obj.thresholdingParams[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceRequest {
    return RunCheckpointBasedInferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceRequest {
    const message = createBaseRunCheckpointBasedInferenceRequest();
    message.image = object.image ?? new Uint8Array(0);
    message.modelPath = object.modelPath ?? "";
    message.modelType = object.modelType ?? "";
    message.thresholdingParams = Object.entries(object.thresholdingParams ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry(): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
  return { key: "", value: "" };
}

export const RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry: MessageFns<
  RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry
> = {
  encode(
    message: RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    return RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry {
    const message = createBaseRunCheckpointBasedInferenceRequest_ThresholdingParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseRunCheckpointBasedInferenceResponse(): RunCheckpointBasedInferenceResponse {
  return { data: undefined, error: undefined };
}

export const RunCheckpointBasedInferenceResponse: MessageFns<RunCheckpointBasedInferenceResponse> = {
  encode(message: RunCheckpointBasedInferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      CheckpointBasedInferenceResult.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunCheckpointBasedInferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunCheckpointBasedInferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = CheckpointBasedInferenceResult.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunCheckpointBasedInferenceResponse {
    return {
      data: isSet(object.data) ? CheckpointBasedInferenceResult.fromJSON(object.data) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: RunCheckpointBasedInferenceResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = CheckpointBasedInferenceResult.toJSON(message.data);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RunCheckpointBasedInferenceResponse>, I>>(
    base?: I,
  ): RunCheckpointBasedInferenceResponse {
    return RunCheckpointBasedInferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RunCheckpointBasedInferenceResponse>, I>>(
    object: I,
  ): RunCheckpointBasedInferenceResponse {
    const message = createBaseRunCheckpointBasedInferenceResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? CheckpointBasedInferenceResult.fromPartial(object.data)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

function createBaseCheckpointBasedInferenceResult(): CheckpointBasedInferenceResult {
  return { blobs: [], processingTimeMs: undefined, modelPath: undefined };
}

export const CheckpointBasedInferenceResult: MessageFns<CheckpointBasedInferenceResult> = {
  encode(message: CheckpointBasedInferenceResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.blobs) {
      Blob2D.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.processingTimeMs !== undefined) {
      writer.uint32(16).int32(message.processingTimeMs);
    }
    if (message.modelPath !== undefined) {
      writer.uint32(26).string(message.modelPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckpointBasedInferenceResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckpointBasedInferenceResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.blobs.push(Blob2D.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.processingTimeMs = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckpointBasedInferenceResult {
    return {
      blobs: globalThis.Array.isArray(object?.blobs) ? object.blobs.map((e: any) => Blob2D.fromJSON(e)) : [],
      processingTimeMs: isSet(object.processingTimeMs) ? globalThis.Number(object.processingTimeMs) : undefined,
      modelPath: isSet(object.modelPath) ? globalThis.String(object.modelPath) : undefined,
    };
  },

  toJSON(message: CheckpointBasedInferenceResult): unknown {
    const obj: any = {};
    if (message.blobs?.length) {
      obj.blobs = message.blobs.map((e) => Blob2D.toJSON(e));
    }
    if (message.processingTimeMs !== undefined) {
      obj.processingTimeMs = Math.round(message.processingTimeMs);
    }
    if (message.modelPath !== undefined) {
      obj.modelPath = message.modelPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckpointBasedInferenceResult>, I>>(base?: I): CheckpointBasedInferenceResult {
    return CheckpointBasedInferenceResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckpointBasedInferenceResult>, I>>(
    object: I,
  ): CheckpointBasedInferenceResult {
    const message = createBaseCheckpointBasedInferenceResult();
    message.blobs = object.blobs?.map((e) => Blob2D.fromPartial(e)) || [];
    message.processingTimeMs = object.processingTimeMs ?? undefined;
    message.modelPath = object.modelPath ?? undefined;
    return message;
  },
};

function createBaseError(): Error {
  return { code: 0, message: "" };
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Error {
    return {
      code: isSet(object.code) ? errorCodeFromJSON(object.code) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = errorCodeToJSON(message.code);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError();
    message.code = object.code ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

/** @language: python */
export interface VisionBotService {
  GetModels(request: Empty): Promise<ModelList>;
  RunCheckpointBasedInference(
    request: RunCheckpointBasedInferenceRequest,
  ): Promise<RunCheckpointBasedInferenceResponse>;
}

export const VisionBotServiceServiceName = "visionbot.VisionBotService";
export class VisionBotServiceClientImpl implements VisionBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || VisionBotServiceServiceName;
    this.rpc = rpc;
    this.GetModels = this.GetModels.bind(this);
    this.RunCheckpointBasedInference = this.RunCheckpointBasedInference.bind(this);
  }
  GetModels(request: Empty): Promise<ModelList> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetModels", data);
    return promise.then((data) => ModelList.decode(new BinaryReader(data)));
  }

  RunCheckpointBasedInference(
    request: RunCheckpointBasedInferenceRequest,
  ): Promise<RunCheckpointBasedInferenceResponse> {
    const data = RunCheckpointBasedInferenceRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "RunCheckpointBasedInference", data);
    return promise.then((data) => RunCheckpointBasedInferenceResponse.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/vision_bot_service.proto",
    "package": "visionbot",
    "dependency": ["google/protobuf/empty.proto", "messenger/geometry.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Blob2D",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "width",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "width",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "height",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "height",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rotation",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rotation",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "score",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "score",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "contour",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".geometry.Point2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "contour",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Model",
      "field": [{
        "name": "model_path",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ModelList",
      "field": [{
        "name": "models",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Model",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "models",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunCheckpointBasedInferenceRequest",
      "field": [{
        "name": "image",
        "number": 1,
        "label": 1,
        "type": 12,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "image",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_path",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "model_type",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "modelType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "thresholding_params",
        "number": 4,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.RunCheckpointBasedInferenceRequest.ThresholdingParamsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "thresholdingParams",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [{
        "name": "ThresholdingParamsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RunCheckpointBasedInferenceResponse",
      "field": [{
        "name": "data",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.CheckpointBasedInferenceResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "data",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".visionbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CheckpointBasedInferenceResult",
      "field": [{
        "name": "blobs",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".visionbot.Blob2D",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "blobs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "processing_time_ms",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "processingTimeMs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "model_path",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "modelPath",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_processing_time_ms", "options": undefined }, {
        "name": "_model_path",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Error",
      "field": [{
        "name": "code",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".visionbot.ErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "ErrorCode",
      "value": [
        { "name": "UNKNOWN_ERROR", "number": 0, "options": undefined },
        { "name": "MODEL_NOT_FOUND", "number": 1, "options": undefined },
        { "name": "INVALID_IMAGE", "number": 2, "options": undefined },
        { "name": "INFERENCE_FAILED", "number": 3, "options": undefined },
        { "name": "INVALID_MODEL_TYPE", "number": 4, "options": undefined },
        { "name": "INVALID_THRESHOLDING_PARAMS", "number": 5, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "VisionBotService",
      "method": [{
        "name": "GetModels",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".visionbot.ModelList",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RunCheckpointBasedInference",
        "inputType": ".visionbot.RunCheckpointBasedInferenceRequest",
        "outputType": ".visionbot.RunCheckpointBasedInferenceResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/can/protos/messenger",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [6, 0],
        "span": [8, 0, 11, 1],
        "leadingComments": " @language: python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0],
        "span": [14, 0, 22, 1],
        "leadingComments": " Represents a 2D blob detection result\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1],
        "span": [25, 0, 27, 1],
        "leadingComments": " Available model information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3],
        "span": [34, 0, 43, 1],
        "leadingComments": " Request to run inference on an image\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 0],
        "span": [36, 2, 18],
        "leadingComments": " Image data as bytes\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 1],
        "span": [38, 2, 24],
        "leadingComments": " Path to the model checkpoint file\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 2],
        "span": [40, 2, 24],
        "leadingComments": " Type of model to determine preprocessing/postprocessing\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 3],
        "span": [42, 2, 46],
        "leadingComments": " Model-specific thresholding parameters\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [46, 0, 53, 1],
        "leadingComments": " Response from inference\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4, 2, 0],
        "span": [49, 4, 44],
        "leadingComments": " Successful inference result\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4, 2, 1],
        "span": [51, 4, 20],
        "leadingComments": " Error information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [56, 0, 63, 1],
        "leadingComments": " Successful inference result\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 0],
        "span": [58, 2, 28],
        "leadingComments": " Detected blobs\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 1],
        "span": [60, 2, 40],
        "leadingComments": " Processing time in milliseconds\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 2],
        "span": [62, 2, 33],
        "leadingComments": " Model path\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [66, 0, 69, 1],
        "leadingComments": " Error information\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".visionbot.ErrorCode": ErrorCode,
    ".visionbot.Blob2D": Blob2D,
    ".visionbot.Model": Model,
    ".visionbot.ModelList": ModelList,
    ".visionbot.RunCheckpointBasedInferenceRequest": RunCheckpointBasedInferenceRequest,
    ".visionbot.RunCheckpointBasedInferenceRequest.ThresholdingParamsEntry":
      RunCheckpointBasedInferenceRequest_ThresholdingParamsEntry,
    ".visionbot.RunCheckpointBasedInferenceResponse": RunCheckpointBasedInferenceResponse,
    ".visionbot.CheckpointBasedInferenceResult": CheckpointBasedInferenceResult,
    ".visionbot.Error": Error,
    ".visionbot.VisionBotService": VisionBotServiceClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2],
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
